export default __webpack_public_path__ + "static/media/sqlite.ec360c26.svg";